// extracted by mini-css-extract-plugin
export default {"badge":"index__badge___2Msv5","bounce":"index__bounce___3eL8n"};